// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"CB-z","smallCardRow":"DB-z","largeCardRow":"EB-z","productSearchRow":"FB-z","curatedRow":"GB-z"};